const { REACT_APP_NAME } = process.env;
import { Box, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Skeleton, TextField, Typography } from '@mui/material'
import { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import PageContainer from 'src/components/container/PageContainer'
import { useGetStructureMutation, useGetsssStructureMutation } from 'src/redux/api/cabinet';
import { AppState } from 'src/store/Store';
import { Alerting } from 'src/views/components_cabinet/Alerting';
import { useDispatch } from 'react-redux';
import { upd_structure_history } from '../../../../redux/slices/app';
import { TableAnalizV2 } from './TableAnalizV2';

const programs = [
    { name: 'NULL', id: 7, level: 600 },
    { name: 'MINI', id: 1, level: 1100 },
    { name: 'MIDI', id: 2, level: 5000 },
    { name: 'MAXI', id: 3, level: 25000 },
    { name: 'AUTO', id: 4, level: 300000 },
    { name: 'HOME ', id: 5, level: 3000000 },
    { name: 'SPACE ', id: 6, level: 1000 },
];

export const AnalizPageOffice = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const { data, structure_history } = useSelector((state: AppState) => state.app);
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const [tarif, settarif] = useState('');
    const [closedCount, setclosed] = useState('');
    const [urovni, seturovni] = useState('7_600');
    const [loginuser, setloginuser] = useState(data.login);
    const [rows, setRows] = useState<any[] | undefined>(undefined);
    const [levels, setLevels] = useState<any[] | undefined>(undefined);
    const [isInitialized, setIsInitialized] = useState(false);

    const [userUpdateData, { isLoading }] = useGetStructureMutation();
    const userUpdateRequest = async (body: any) => {
        const jwt = localStorage.getItem('jwt');
        await userUpdateData({ body, jwt })
            .unwrap()
            .then((payload: any) => {
                setRows(payload.data);
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const [dataGetsStructure, { isLoading: isld, isSuccess }] = useGetsssStructureMutation();
    const requestGetsStructure = async () => {
        const jwt = localStorage.getItem('jwt');
        await dataGetsStructure({ jwt })
            .unwrap()
            .then((payload: any) => {
                setLevels(payload.data);
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const updateURLParams = (level: string, login: string, closed: string) => {
        const params: any = {};
        if (level) {
            params.level = level;
        }
        if (login) {
            params.login = login;
        }
        if (closed) {
            params.closed = closed;
        }
        setSearchParams(params);
    };

    const handleClosedCountChange = (value: string) => {
        if (value === '' || /^\d+$/.test(value)) {
            setclosed(value);
            if (isInitialized) {
                updateURLParams(urovni, loginuser, value);
            }
        }
    };

    const changeurovni = (event: SelectChangeEvent) => {
        const newLevel = event.target.value as string;
        seturovni(newLevel);
        if (isInitialized) {
            updateURLParams(newLevel, loginuser, closedCount);
        }
    };

    const changeLoginUser = (event: string) => {
        setloginuser(event);
        if (isInitialized) {
            updateURLParams(urovni, event, closedCount);
        }
    };

    const changeHistory = (u: any, t: any, l: any) => {
        dispatch(upd_structure_history({ u, t, l }));
    }

    const getNewStructure = () => {
        if (!urovni) {
            setgetAlert({ type: 2, msg: "Для поиска необходимо выбрать уровень" });
            return false
        }

        if (loginuser.length < 2) {
            setgetAlert({ type: 2, msg: "Для поиска необходимо ввести Логин" });
            return false
        }

        const find = {
            closed: closedCount,
            level: urovni,
            login: loginuser
        }

        changeHistory(urovni, tarif, loginuser);
        userUpdateRequest(find);
        updateURLParams(urovni, loginuser, closedCount);
    }

    useEffect(() => {
        const initializeComponent = async () => {
            await requestGetsStructure();

            const urlLevel = searchParams.get('level');
            const urlLogin = searchParams.get('login');
            const urlClosed = searchParams.get('closed');

            let initialLevel = '7_600';
            let initialLogin = data.login;
            let initialClosed = '';
            let shouldLoadData = false;

            if (urlLevel) {
                initialLevel = urlLevel;
                shouldLoadData = true;
            } else if (structure_history) {
                initialLevel = structure_history.u;
            }

            if (urlLogin) {
                initialLogin = urlLogin;
                shouldLoadData = true;
            } else if (structure_history) {
                initialLogin = structure_history.l;
            }

            if (urlClosed) {
                initialClosed = urlClosed;
            }

            seturovni(initialLevel);
            setloginuser(initialLogin);
            setclosed(initialClosed);

            if (structure_history) {
                settarif(structure_history.t);
            }

            changeHistory(initialLevel, structure_history?.t || '7', initialLogin);

            if (!urlLevel && !urlLogin && !urlClosed) {
                updateURLParams(initialLevel, initialLogin, initialClosed);
            }

            if (shouldLoadData && initialLogin.length >= 2 && initialLevel) {
                const find = {
                    closed: initialClosed,
                    level: initialLevel,
                    login: initialLogin
                }
                await userUpdateRequest(find);
            }

            setIsInitialized(true);
        };

        initializeComponent();
    }, [])

    useEffect(() => {
        if (structure_history && !isInitialized) {
            settarif(structure_history.t);
            seturovni(structure_history.u);
            setloginuser(structure_history.l);
        }
    }, [structure_history])

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            <PageContainer title={`${REACT_APP_NAME} | Структура`} description="Структура">
                <Box sx={{ my: 2 }}>
                    <Box>
                        {isLoading && <>
                            <Box sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', minHeight: "40vh" }}>
                                <CircularProgress />
                            </Box>
                        </>}

                        {!isLoading && !isld &&
                            <Card>
                                <CardHeader
                                    title="Структура"
                                />
                                <CardContent>
                                    <form>
                                        <Grid container spacing={1}>
                                            <Grid item sx={{ mb: { xs: 1, md: 0 } }} xs={12} md={4}>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        value={loginuser}
                                                        onInput={(e: ChangeEvent<HTMLInputElement>) => changeLoginUser(e.target.value)}
                                                        label={<Typography sx={{ fontSize: "1.2rem" }}>
                                                            Логин
                                                        </Typography>} variant="outlined"
                                                        sx={{ fontSize: "1.2rem", "& > fieldset > legend": { fontSize: "1.2rem" } }}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item sx={{ mb: { xs: 1, md: 0 } }} xs={12} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel sx={{ zIndex: 7788, fontSize: "1.2rem" }}>Уровни</InputLabel>
                                                    <Select
                                                        sx={{ background: '#eaeaea', "& .MuiOutlinedInput-notchedOutline": { background: "transparent" } }}
                                                        value={urovni}
                                                        label="Уровни"
                                                        onChange={changeurovni}
                                                    >
                                                        {levels && levels.map((e, i) => {
                                                            return <MenuItem key={i} value={String(e.value)}>{e.title}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item sx={{ mb: { xs: 1, md: 0 } }} xs={12} md={4}>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        value={closedCount}
                                                        onInput={(e: ChangeEvent<HTMLInputElement>) => handleClosedCountChange(e.target.value)}
                                                        inputProps={{ inputMode: 'numeric' }}
                                                        label={<Typography sx={{ fontSize: "1.2rem" }}>
                                                            Кол-во занятых мест
                                                        </Typography>} variant="outlined"
                                                        sx={{ fontSize: "1.2rem", "& > fieldset > legend": { fontSize: "1.2rem" } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Box mt={2} display='flex' sx={{ justifyContent: { xs: "center", md: "end" } }}>
                                            <Button onClick={getNewStructure}
                                                type='submit'
                                                size="large" color='success'
                                                sx={{ background: "green", color: "white", ml: 'auto', px: 5, fontSize: 18 }}
                                            >
                                                Найти
                                            </Button>
                                        </Box>
                                    </form>
                                </CardContent>
                            </Card>
                        }

                        <Box sx={{ mt: 3 }}>
                            {!isLoading && rows && <TableAnalizV2 data={rows} />}
                            {!rows && !isLoading && isSuccess && <Typography textAlign='center' variant='h4' my={10}>Структура анализа не найдена</Typography>}
                        </Box>
                    </Box>
                </Box>
            </PageContainer>
        </>
    )
}